var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.112,
    height: 41.996,
    viewBox: "0 0 24.112 41.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M38.971,11.424,27.547,0,16.034,11.513a2.006,2.006,0,0,0,2.837,2.837l6.735-6.735V39.991a2.005,2.005,0,1,0,4.01,0V7.743l6.518,6.518a2.006,2.006,0,1,0,2.837-2.837",
    transform: "translate(39.559 41.996) rotate(180)",
    fill: "#49bcc6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.c2b0c7e5a22fcc5c300ce5169bedcd60.svg";
export { ForwardRef as ReactComponent };